import axios from "axios"

const API_URL = process.env.REACT_APP_API_URL
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID
const GOOGLE_CLIENT_SECRET = process.env.REACT_APP_GOOGLE_CLIENT_SECRET
const GOOGLE_REDIRECT_URI_DEV = 'https://crm-dev.wooblazz.com'
const GOOGLE_REDIRECT_URI_STAGING = 'https://crm-staging.wooblazz.com'
const GOOGLE_REDIRECT_URI_PROD = 'https://crm.wooblazz.com'
const APP_ENV = process.env.REACT_APP_ENV
const APP_ENV_LOCAL = process.env.REACT_APP_ENV_LOCAL
const localhost = 'http://localhost:3011'

interface VerifyGoogleCalendarProps {
    access_token: string
    refresh_token: string
    expiry_date: number
    token_type: string
}

interface SyncGoogleCalendarProps {
    token: string
    // calendarId: string
}

export const setCodeGoogleCalendar = async (code: string) => {
    try {
        const response = await axios.post('https://oauth2.googleapis.com/token', {
            client_id: GOOGLE_CLIENT_ID,
            client_secret: GOOGLE_CLIENT_SECRET,
            code: code,
            redirect_uri: APP_ENV_LOCAL === 'localhost' ? localhost : APP_ENV === 'development' ? GOOGLE_REDIRECT_URI_DEV : APP_ENV === 'staging' ? GOOGLE_REDIRECT_URI_STAGING : APP_ENV === 'production' ? GOOGLE_REDIRECT_URI_PROD : '',
            grant_type: 'authorization_code',
        })
        return response.data
    } catch (error) {
        console.log(error, 'error')
    }
}


export const setVerifyGoogleCalendar = async (data: VerifyGoogleCalendarProps, token: string) => {
    try {
        const response = await axios.post(`${API_URL}auth/google/verify`, {
            tokens: {
                access_token: data.access_token,
                refresh_token: data.refresh_token,
                expiry_date: data.expiry_date,
                token_type: data.token_type,
            },
        }, {
            headers: {
                'X-Auth-Token': token,
            },
        })
        return response.data
    } catch (error) {
        console.log(error, 'error')
    }
}

export const getIsSignInGoogle = async (token: string) => {
    try {
        const response = await axios.get(`${API_URL}auth/google`, {
            headers: {
                'X-Auth-Token': token,
            }
        })
        return response.data
    } catch (error) {
        console.log(error, 'error')
    }
}

export const getProfileAccountByToken = async (token: string) => {
    try {
        const response = await axios.get(`${API_URL}auth/google/info`, {
            headers: {
                'X-Auth-Token': token,
            }
        })
        return response.data
    } catch (error) {
        console.log(error, 'error')
    }
}

export const signOutGoogle = async (token: string) => {
    try {
        const response = await axios.post(`${API_URL}auth/google/logout`, {}, {
            headers: {
                'X-Auth-Token': token,
            }
        })
        return response.data
    } catch (error) {
        console.log(error, 'error')
    }
}

export const syncGoogleCalendar = async ({ token }: SyncGoogleCalendarProps) => {
    try {
        // const response = await axios.post(`${API_URL}google-calender/sync?calendarId=${calendarId}`, {}, {
        const response = await axios.post(`${API_URL}google-calender/sync`, {}, {
            headers: {
                'X-Auth-Token': token,
            }
        })
        return response.data
    } catch (error) {
        console.log(error, 'error')
    }
}


export const deleteEventGoogleCalendar = async (token: string, eventId: string) => {
    try {
        const response = await axios.delete(`${API_URL}google-calender/delete-event-crm?calendarId=${eventId}`, {
            headers: {
                'X-Auth-Token': token,
            }
        })
        return response.data

    } catch (error) {
        console.log(error)
    }
}